import React from 'react'
import { connect } from 'react-redux'
import './profile.styles.scss'

const ProfilePage = (props) => {
    const firstname = props.auth.profile?.firstname || ""
    const lastname = props.auth.profile?.lastname || ""
    const email = props.auth.profile?.email || props.auth.profile?.username || "-"

    return (
        <div className="profile-page">
            <div className="card">
                <div className="header">
                    <h4>Profile</h4>
                </div>
                <div className="profile-details">
                    <div className="detail-row">
                        <strong>Name</strong>
                        <span>{(firstname + " " + lastname).trim() || "-"}</span>
                    </div>
                    <div className="detail-row">
                        <strong>Email</strong>
                        <span>{email}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(ProfilePage)
